/** Whole years since `birthDate` (a plain `YYYY-MM-DD`), counted in local time. */
export function ageFrom(birthDate: string, now = new Date()): number {
  const [y, m, d] = birthDate.split('-').map(Number)
  let age = now.getFullYear() - y
  if (now.getMonth() + 1 < m || (now.getMonth() + 1 === m && now.getDate() < d)) age--
  return age
}
